<template>
	<div>
		<ProductTilesContainer></ProductTilesContainer>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ProductTilesContainer from './components/ProductTilesContainer/ProductTilesContainer.vue';
import { useStore } from 'vuex';
import store, { RootState } from './store';

export default defineComponent({
	name: 'App',
	components: {
		ProductTilesContainer
	},
	data() {
		return {
			configurationParams: {
				catalogId: "",
				storeId: "",
				langId: "",
				categoryId: "",
				earlyAccessEnabled: false,
				searchHostName: "",
				isSearchPage: false,
				completePairMode: "GL_BRAND_RAY-BAN,GL_BRAND_OAKLEY,GL_BRAND_COSTA,GL_BRAND_PERSOL,GL_SAFETYGLASSES",
				completePairLabel: "including lenses",
				inStockFacet: "ads_f49001",
				hostName: "developer.glasses.com",
				categoryName: '',
				isSeoCustomPLP: false,
				amlImageHost: 'https://assets2.glasses.com/',
				isSpeedyPLP: false,
				isSpeedyRxEnabled: false,
				isFlatPLP: false,
			},
		};
	},
	created() {
		this.initializeData();
		this.poulateCategories();
	},
	methods: {
		initializeData() {
			const plpComponentRoot = document.getElementById("plp-app");
			const host = window.location.host;
			let minPriceFilter = 0;
			let maxPriceFilter = 1000;
			if (host != 'localhost:8081' && plpComponentRoot != undefined) {
				this.configurationParams.catalogId = plpComponentRoot.getAttribute("data-catalog-id") as string;
				this.configurationParams.storeId = plpComponentRoot.getAttribute("data-store-id") as string;
				this.configurationParams.langId = plpComponentRoot.getAttribute("data-lang-id") as string;
				this.configurationParams.categoryId = plpComponentRoot.getAttribute("data-category-id") as string;
				this.configurationParams.earlyAccessEnabled = plpComponentRoot.getAttribute("data-early-access") == 'true';
				this.configurationParams.searchHostName = 'https://' + window.location.hostname;
				this.configurationParams.isSearchPage = (plpComponentRoot.getAttribute("data-is-search-page") == 'true');
				this.configurationParams.completePairMode = (plpComponentRoot.getAttribute("data-complete-pair-mode")) as string;
				this.configurationParams.completePairLabel = (plpComponentRoot.getAttribute("data-complete-pair-label")) as string;
				this.configurationParams.inStockFacet = (plpComponentRoot.getAttribute("data-in-stock-facet")) as string;
				this.configurationParams.categoryName = (plpComponentRoot.getAttribute("data-category-name")) as string;
				this.configurationParams.isSeoCustomPLP = plpComponentRoot.getAttribute("data-seo-custom-category") == 'true';
				this.configurationParams.isSpeedyPLP = (plpComponentRoot.getAttribute("data-category-name") == 'gl-speedy-rx');
				this.configurationParams.amlImageHost = (plpComponentRoot.getAttribute("data-aml-image-host")) as string;
				this.configurationParams.isSpeedyRxEnabled = (plpComponentRoot.getAttribute("data-is-speedy-rx-enabled") == 'true');
				this.configurationParams.isFlatPLP = (plpComponentRoot.getAttribute("data-flat-plp") == 'true');
				const minPriceAttribute = plpComponentRoot.getAttribute("data-min-price-filter");
				const maxPriceAttribute = plpComponentRoot.getAttribute("data-max-price-filter");
				if (minPriceAttribute) {
					minPriceFilter = parseInt(minPriceAttribute, 10) || 0;
				}
				if (maxPriceAttribute) {
					maxPriceFilter = parseInt(maxPriceAttribute, 10) || 0;
				}
				this.configurationParams.hostName = window.location.hostname;

			} else {
				this.configurationParams.catalogId = "23201";
				this.configurationParams.storeId = "15951";
				this.configurationParams.langId = "-1";
				this.configurationParams.categoryId = "99958714";
				this.configurationParams.earlyAccessEnabled = false;
				this.configurationParams.searchHostName = "http://lrronafed02.luxgroup.net:3737";
				this.configurationParams.isSearchPage = false;
				this.configurationParams.isSpeedyPLP = false;
				this.configurationParams.isSpeedyRxEnabled = false;
				this.configurationParams.isFlatPLP = false;
				minPriceFilter = 0;
				maxPriceFilter = 1000;
			}

			// Accediamo al Vuex store
			const store = useStore<RootState>();
			store.commit("setParams", this.configurationParams);
			store.commit("setPriceFilters", { minPrice: minPriceFilter, maxPrice: maxPriceFilter });
		},
		async poulateCategories() {
			const store = useStore();
			const categoriesIdentifier = ["gl_bestsellers", "gl_bestsellers_Sunglasses", "gl_bestsellers_Eyeglasses", "gl_newarrivals", "gl_newarrivals_sunglasses", "gl_newarrivals_eyeglasses",
				"gl_trends_Sustainable Glasses", "gl_clearance", "gl_clearance_Sunglasses", "gl_clearance_Eyeglasses"];
			const updatedCategoriesIdentifier = categoriesIdentifier.concat(
				this.configurationParams.completePairMode.split(",")
			);
			await store.dispatch('initializeCategories', updatedCategoriesIdentifier);
		}
	},
});
</script>

<style lang="scss">
#plp-app {
	font-family: "DM Sans", sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #222222;
	overflow-x: hidden;
}
</style>